import { BodyMediumMidEmphasis, ButtonFlatMedium, TitleSmallEmphasized } from '@/design-system';
import { KeyboardArrowDown } from '@mui/icons-material';
import { FlyerType } from '@/config/constants';
import cloudWomanIcon from '@/assets/cloud-woman.svg';
import styles from './ViewMoreCard.styles';

interface Props {
  title: string;
  description: string;
  buttonLabel: string;
  onClick: () => void;
}

export const ViewMoreCard: React.FC<Props> = ({ title, description, buttonLabel, onClick }) => (
  <div className={styles.container}>
    <TitleSmallEmphasized data-testid="viewMoreCardTitle">{title}</TitleSmallEmphasized>
    <BodyMediumMidEmphasis data-testid="viewMoreCarDescription">
      {description}
    </BodyMediumMidEmphasis>
    <ButtonFlatMedium
      onClick={onClick}
      className={styles.button}
      endAdornment={<KeyboardArrowDown />}
      data-testid="viewMoreCardButton"
    >
      {buttonLabel}
    </ButtonFlatMedium>
    <img src={cloudWomanIcon} width="87.4px" height="65.5px" alt="" className={styles.icon} />
  </div>
);
